import { NgModule } from '@angular/core';
import { MonitorService } from './shared/monitor.service';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { MonitorStatusComponent } from './monitor-status/monitor-status.component';
import { MonitoringComponent } from './monitoring.component';
import { MonitorHttpComponent } from './monitor-http/monitor-http.component';
import { MONITORING_ROUTES } from './monitoring.routes';

@NgModule({
  imports: [
    RouterModule.forChild(MONITORING_ROUTES),
    SharedModule
  ],
  declarations: [
    MonitoringComponent,
    MonitorStatusComponent,
    MonitorHttpComponent
  ],
  providers: [
    MonitorService
  ]
})
export class MonitoringModule {
}
